import { useCpFormAnyValue, useCpFormDirty, useCpFormErrorWarning } from "./utils";

interface Props {
  names: string[];
}

export function CpDirtyIndicatorArrayIcon({ names }: Props) {
  const res = useCpFormErrorWarning(names);
  const dirty = useCpFormDirty(names || []);
  const submitted = useCpFormAnyValue(`meta.submitted`);

  if (dirty && (!submitted || (!res.error && !res.warning))) {
    return (
      <span
        className="dirty-indicator"
        style={{
          display: "inline-block",
          borderRadius: "100%",
          marginLeft: 4,
          width: 8,
          height: 8,
        }}
      />
    );
  }

  return null;
}

interface Props2 {
  names: string[];
}
export function CpDirtyIndicatorArrayIconLink({ names }: Props2) {
  const res = useCpFormErrorWarning(names || []);
  const dirty = useCpFormDirty(names || []);
  const submitted = useCpFormAnyValue(`meta.submitted`);

  if (dirty && (!submitted || (!res.error && !res.warning))) {
    return (
      <span
        className="dirty-indicator"
        style={{
          display: "inline-block",
          borderRadius: "100%",
          transform: "translateY(-1px)",
          marginLeft: 4,
          width: 8,
          height: 8,
        }}
      />
    );
  }

  return null;
}
